import React from "react";
import { Loader } from "./LoadingSpinner.styles";

function LoadingSpinner({ width = 20, height = 20, style, color = "#fff" }) {
  return <Loader width={width} height={height} style={style} $color={color} />;
}

export default LoadingSpinner;
